import Api from './api';

// Item 09b (16/10/2026) — CRUD dos templates do copiloto de fluxo (API 2DO).
const PATH = '/chatbot-flow-copilot-templates';

export const normalizeCopilotTemplate = (t) => ({
  id: t?.id,
  code: t?.code ?? null,
  title: t?.title ?? '',
  description: t?.description ?? '',
  boxesSummary: t?.boxessummary ?? t?.boxesSummary ?? '',
  prompt: t?.prompt ?? '',
  mode: t?.mode ?? 'create',
  isSystem: t?.issystem ?? t?.isSystem ?? false,
  active: t?.active ?? true,
  sortOrder: t?.sortorder ?? t?.sortOrder ?? 1000,
  canEdit: t?.canedit ?? t?.canEdit ?? false,
  updatedUserName: t?.updatedusername ?? t?.updatedUserName ?? '',
  updatedAt: t?.updatedat ?? t?.updatedAt ?? null,
});

const getAll = async () => {
  try {
    const response = await Api.get(PATH);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const create = async (payload) => {
  try {
    const response = await Api.post(PATH, payload);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const update = async (id, payload) => {
  try {
    const response = await Api.put(`${PATH}/${id}`, payload);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const remove = async (id) => {
  try {
    const response = await Api.delete(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const restoreDefault = async (id) => {
  try {
    const response = await Api.post(`${PATH}/${id}/restore-default`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export {
  getAll,
  create,
  update,
  remove,
  restoreDefault,
};
